import { BroadcastLiveWebinar } from '@live-webinar/broadcast';
import { RouterType } from '@online-webinar/router';
import { authGuard } from '../integrations/auth-guard';

export const updateRoute = (router: RouterType) => {
    router.routesById['/$webinarId/broadcast'].update({
        staticData: { title: { webinar: 'Title.BroadcastWebinar' } },
        component: authGuard(BroadcastLiveWebinar, { canBroadcast: true })
    });
};
